<template>
  <div class="docsDetail">
    <el-card shadow="never" :class="{ important: isImportant(doc) }">
      <div class="body">
        <div class="titolo col-24">{{ (doc.container) === undefined ? '&nbsp' : $i18n.t('docs.documentType.' +
          doc.container + '.label') }}</div>
        <div class="testo col-24">{{ getTitolo(doc) }}</div>
        <div class="data col-24">{{ getDate(doc) }}</div>
      </div>
      <div class="icon" @click="getDoc(doc)">
        <icon name="riv-pdfOro" scale="2"></icon>
        <!--<img src="../../../static/img/pdf-file.png" alt="Flowers in Chania">-->
      </div>
    </el-card>
  </div>
</template>

<script>
import mixinDownload from "../../assets/mixins/downloadDoc.js";

export default {
  name: 'GridDoc',
  mixins: [mixinDownload],
  props: ['doc', 'showInDashboard'],
  data() {
    return {
      baseUrl: process.env.baseUrl
    }
  },
  i18n: {},
  computed: {
    homeStyle: function () {
      let path = this.$route.path
      return (path.indexOf('/documenti/') !== 0)
    }
  },
  mounted: function () {
  },
  methods: {
    setMessaggioService: function () {
      let data = new FormData()
      data.append('id', messaggio.id)
      data.append('op', operazione)
      this.$http.post('documenti/' + this.$store.state.country + '/savereaddoc', data)
        .then(response => {
          if (response.body.rc === 0) {

            // Se op L ricalcolo tutti i messaggi da leggere
            if (operazione === 'L') {
              let messaggiCount = this.$store.state.messaggiCount
              if (messaggiCount[messaggio.tipo] !== undefined && messaggiCount[messaggio.tipo] > 0) {
                messaggiCount[messaggio.tipo] = messaggiCount[messaggio.tipo] - 1
              }
              if (messaggiCount.totale !== undefined && messaggiCount.totale > 0) {
                messaggiCount.totale = messaggiCount.totale - 1
              }
              this.$store.commit('set', { key: 'messaggiCount', value: messaggiCount })
              bus.$emit('changeMessaggiCount')
            }
            // Togliere load e cambiare lo stato del documento letto
            if (this.indexMsg !== '' && operazione === 'L')
              this.$set(this.com[this.indexMsg], 'seLetto', 'Y')
            if (this.indexMsg !== '' && operazione === 'P')
              this.$set(this.com[this.indexMsg], 'presaVis', 'Y')
            // this.loadCom()
            if (closeModal) {
              this.$set(this, 'showModal', false)
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    getTitolo: function (doc) {
      if (doc.container === undefined) {
        return doc.oggetto
      } else if (doc.container == 'PAFPAGLETGEN') {
        return doc.tdo
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return doc.tit
      } else {
        return ''
      }
    },
    getDate: function (doc) {
      if (doc.container === undefined) {
        return ''
      } else if (doc.container == 'PAFPAGLETGEN') {
        return this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return doc.datada
      } else if (doc.container == 'PAIPAGMODCUD') {
        return doc.anno
      } else {
        return this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      }
    },
    getNome: function (doc) {
      if (doc.container === undefined) {
        return doc.oggetto
      } else if (doc.container == 'PAFPAGLETGEN') {
        let nome = this.$i18n.t('docs.documentType.' + doc.container + '.label') + + ' ' + doc.tdo
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return '[' + doc.datada + ']' + ' ' + doc.tit
      } else if (doc.container == 'PAIPAGMODCUD') {
        let nome = this.$i18n.t('docs.documentType.' + doc.container + '.label')
        return nome + ' ' + doc.anno
      } else if (doc.container === undefined) {
        return 'generic'
      } else {
        let nome = this.$i18n.t('docs.documentType.' + doc.container + '.label')
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      }
    },
    getNomeUrl: function (doc) {
      if (doc.container == 'PAFPAGLETGEN') {
        let nome = this.$i18n.t('documentType.' + doc.container + '.label', { titolo: '' })
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return '[' + doc.datada + ']' + ' ' + doc.tit
      } else {
        let nome = this.$i18n.t('documentType.' + doc.container + '.label')
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      }
      this.setMessaggioService()
    },
    isImportant: function (doc) {
      if (doc.seRead === 'N') {
        // Documenti a cui è stata fatta la Presa Visione
        return true
      } else {
        return false
      }
    },
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.docsDetail {
  .padding-2 {
    padding-left: 3px;
    padding-right: 3px;
  }

  .el-card {
    width: 100%;
    height: 80px;
    float: left;
    margin-bottom: 10px;
    border-radius: 0px;
    border-top-right-radius: 25px;
    padding: 5px 10px !important;

    .el-card__body {
      padding: 0;
      height: 100%;

      .body {
        width: 80%;
        float: left;
        text-align: left;

        //padding-right: 5px;
        .titolo {
          height: 30px;
          width: 80%;
          .set-font(@family: 'os-semibold', @color: #007E85, @size: 16px);
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .testo {
          height: 50px;
          // padding: 0 5px !important;
          .set-font(@size: 12px; @color: @textTable);
          text-align: left;
          word-break: break-word;
        }

        .data {
          .set-font(@color: #9AA0A7, @size: 12px);
          float: left;
          line-height: 20px;
          //font-style: italic;
          padding-top: 2px;
        }
      }

      .icon {
        height: 102px;
        padding-top: 70px;

        .fa-icon {
          width: 20%;
          float: left;
          cursor: pointer;
          color: #007E85;
        }
      }
    }

    & .selected {
      background-color: @hoverTbl;
    }

    & .important {
      border-left: 3px solid @rossoRiva;

      .testo {
        word-break: break-word;
        .set-font(@color: @textTable, @size: 12px, @family: 'os-bold') !important;
      }

      .footer {
        .data {
          .set-font(@color: #9AA0A7, @size: 11px, @family: 'os-bold') !important;
          font-style: normal;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Documenti/gridDoc.vue